import { render, staticRenderFns } from "./orange_his.vue?vue&type=template&id=4e59739e&scoped=true"
import script from "./orange_his.vue?vue&type=script&lang=js"
export * from "./orange_his.vue?vue&type=script&lang=js"
import style0 from "./orange_his.vue?vue&type=style&index=0&id=4e59739e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e59739e",
  null
  
)

export default component.exports